<template>
    <div class="flex justify-end gap-2">
        <slot />
    </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
    size?: 'md'
}>(), {
    size: 'md',
})
</script>
